
var selectedTick;
var checkAction = false;
var siteurl = "http://mwg.fatfish.com.au/";

$(document).ready(function ($) {


    // Fix Safari Modal Scroll Bug

    $.fn.mobileFix = function (options) {
        var $parent = $(this),
            $fixedElements = $(options.fixedElements);

        $(document)
            .on('focus', options.inputElements, function(e) {
                $parent.addClass(options.addClass);
            })
            .on('blur', options.inputElements, function(e) {
                $parent.removeClass(options.addClass);

                // Fix for some scenarios where you need to start scrolling
                setTimeout(function() {
                    $(document).scrollTop($(document).scrollTop())
                }, 1);
            });

        return this; // Allowing chaining
    };

    if (Modernizr.touch && ( $(window).width() <= 768 ) ) {

        $("body").mobileFix({ // Pass parent to apply to
            inputElements: "input,textarea,select", // Pass activation child elements
            addClass: "fixfixed" // Pass class name
        });
    }

    // End Safari Modal Scroll Bug Fix

    jQuery(document).bind('gform_post_render', function(){

        $('.book-appointment-form .select2').remove();

        $(".modal-content select, .jumbotron select, .pagination select").select2({

            minimumResultsForSearch: Infinity

        });

    });

    // Menu bar hover states self explanatory

    $('.jmenu').on('click touchend',function(e) {
        e.stopPropagation();

        $('.jtarget').slideToggle();


    });

    // Accordion for mobile

    $('.title.accord').on('click touchend', function(e) {
        e.stopPropagation();
        e.preventDefault();

        if($(window).width() <= '992'){

            $(this).toggleClass('active');

            if($(this).hasClass('trend')){

                $('.scroller.accordion-content').slideToggle();

            }else{

                $(this).next().slideToggle();

            }

            if($(this).hasClass('slide')){

                $('.news-scroller, .trending-scroller').resize();

            }

        }

    });

    // Display Mobile Menu
    var $lefty = $('.mobile-menu');

    $lefty.css({

        display: 'block',
        right: -$lefty.outerWidth()   - 992

    });

    $('.navbar, .arrow-right-circle').on('click touchend', function(e) {
        e.stopPropagation();

        $lefty.toggleClass('active');

        if($lefty.hasClass('active')){

            $('html, body').css({

                'overflow' : 'hidden'

            })

        }else{

            $('html, body').css({

                'overflow' : 'auto'

            })

        }

        $lefty.animate({
            right: parseInt($lefty.css('right'),10) == 0 ?
                -$lefty.outerWidth() - 992:
                0
        });

    });

    var initial = 0;

    function updateDashItems(sortType){

        var newattr = $(this).attr('data-newpos');

        if(typeof newattr !== typeof undefined && newattr !== false){

            $(this).removeAttr('data-newpos');
            initial = initial -1;

            $('.dash-item').each(function(){

                if(typeof $(this).attr('data-newpos') !== typeof undefined && $(this).attr('data-newpos') !== false){


                }else{

                    $(this).insertAfter(".sort-area > .dash-item:last-child");

                }

            });

        }else{

            if(initial == 0){

                $('.sort-area').prepend($(this));

            } else {

                $($(this)).insertAfter(".sort-area > .dash-item:nth-child(" + initial + ")");

            }

            $(this).attr('data-newpos',initial);
            initial = initial + 1;

        }

    }

    $('#favouriteSort').on('click touchend',function(e) {
        e.stopPropagation();


        $(this).children('.icon').toggleClass('alt');

        var newattr = $('#favouriteItem').attr('data-newpos');

        if(typeof newattr !== typeof undefined && newattr !== false){

            $('#favouriteItem').removeAttr('data-newpos');
            initial = initial -1;

            $('.dash-item').each(function(){

                if(typeof $(this).attr('data-newpos') !== typeof undefined && $(this).attr('data-newpos') !== false){


                }else{

                    $(this).insertAfter(".sort-area > .dash-item:last-child");

                }

            });

        }else{

            if(initial == 0){

                $('.sort-area').prepend($('#favouriteItem'));

            } else {

                $('#favouriteItem').insertAfter(".sort-area > .dash-item:nth-child(" + initial + ")");

            }

            $('#favouriteItem').attr('data-newpos',initial);
            initial = initial + 1;

        }

    });

    $('table').each(function(){

        $(this).wrap('<div class="table-holder"></div>');

    })

    $('#progressSort').on('click touchend',function(e) {
        e.stopPropagation();

        $(this).children('.icon').toggleClass('alt');

        var newattr = $('#journeyItem').attr('data-newpos');

        if(typeof newattr !== typeof undefined && newattr !== false){

            $('#journeyItem').removeAttr('data-newpos');
            initial = initial -1;

            $('.dash-item').each(function(){

                if(typeof $(this).attr('data-newpos') !== typeof undefined && $(this).attr('data-newpos') !== false){


                }else{

                    $(this).insertAfter(".sort-area > .dash-item:last-child");

                }

            });

        }else{

            if(initial == 0){

                $('.sort-area').prepend($('#journeyItem'));

            } else {

                $('#journeyItem').insertAfter(".sort-area > .dash-item:nth-child(" + initial + ")");

            }


            $('#journeyItem').attr('data-newpos',initial);
            initial = initial + 1;

        }
    });

    $('#goalSort').on('click touchend',function(e) {
        e.stopPropagation();

        $(this).children('.icon').toggleClass('alt');

        var newattr = $('#goalItem').attr('data-newpos');

        if(typeof newattr !== typeof undefined && newattr !== false){

            $('#goalItem').removeAttr('data-newpos');
            initial = initial -1;

            $('.dash-item').each(function(){

                if(typeof $(this).attr('data-newpos') !== typeof undefined && $(this).attr('data-newpos') !== false){


                }else{

                    $(this).insertAfter(".sort-area > .dash-item:last-child");

                }

            });

        }else{

            if(initial == 0){

                $('.sort-area').prepend($('#goalItem'));

            } else {

                $('#goalItem').insertAfter(".sort-area > .dash-item:nth-child(" + initial + ")");

            }


            $('#goalItem').attr('data-newpos',initial);
            initial = initial + 1;

        }
    });

    $('#cashflowSort').on('click touchend',function(e) {
        e.stopPropagation();


        $(this).children('.icon').toggleClass('alt');

        var newattr = $('#cashflowItem').attr('data-newpos');

        if(typeof newattr !== typeof undefined && newattr !== false){

            $('#cashflowItem').removeAttr('data-newpos');
            initial = initial -1;

            $('.dash-item').each(function(){

                if(typeof $(this).attr('data-newpos') !== typeof undefined && $(this).attr('data-newpos') !== false){


                }else{

                    $(this).insertAfter(".sort-area > .dash-item:last-child");

                }

            });

        }else{

            if(initial == 0){

                $('.sort-area').prepend($('#cashflowItem'));

            } else {

                $('#cashflowItem').insertAfter(".sort-area > .dash-item:nth-child(" + initial + ")");

            }


            $('#cashflowItem').attr('data-newpos',initial);
            initial = initial + 1;

        }
    });

    $(window).resize(function(){

        if($lefty.hasClass('active')){

            $lefty.css({
                right: parseInt($lefty.css('right'),10) != 0 ?
                    -$lefty.outerWidth()  - 992 :
                    0
            });

        }

        $('.page-lost .internal').css({

            'height' :  $('.background-image img').height() >= 600 ? $('.background-image img').height() : 'auto'

        })

        if($('.background-image img').height() >= 600){

            $('.background-image img').css({

                'display' : 'block'

            })

        }else{

            $('.background-image img').css({

                'display' : 'none'

            })

        }

        setupSnap();

    }).resize();

    var snapWidth;

    function setupSnap(){

        $('.module .snap-box').css({

            'width' : $('.col-md-8').width(),
            'position' : 'relative',
            'bottom' : 'auto',
            'top' : 'auto'

        });

        if($(window).width() >= '768'){

            $(window).on('scroll', function () {

                var y_scroll_pos = window.pageYOffset;
                var scroll_pos_test = 37;

                if (y_scroll_pos > scroll_pos_test && ((parseInt($(window).height() + ($('.menu-bar').height() * 2))) < $(document).height())) {

                    $('.menu-bar').addClass('snap');
                    $('.page-body, .jumbotron').css({

                        'margin-top' : $('.menu-bar').height()

                    });


                } else {

                    $('.menu-bar').removeClass('snap');
                    $('.page-body, .jumbotron').css({

                        'margin-top' : '0'

                    });

                }

                /*if($('.snap-box').length){

                    var scrollTop     = $(window).scrollTop(),
                        elementOffset = $('.snap-box').offset().top,
                        distance      = (elementOffset - scrollTop);

                    if(distance <= 120 && ($('.snap-box').offset().top + $('.snap-box').outerHeight()) >= ($('.sidebar').offset().top + $('.sidebar').outerHeight())){

                        $('.module .col-md-8').css({

                            'position' : 'static'

                        });

                        $('.module .snap-box').removeClass('snap');

                        $('.module .snap-box').css({

                            'width' : $('.col-md-8').width(),
                            'position' : 'absolute',
                            'bottom' : '0',
                            'top' : 'auto'

                        });

                    } else if(window.pageYOffset > '220' && distance >= 120){

                        console.log('snap');
                        $('.module .snap-box').addClass('snap');

                        snapWidth = $('.snap-box').width();

                        $('.module .col-md-8').css({

                            'position' : 'relative'

                        });

                        $('.module .snap-box').css({

                            'width' : $('.col-md-8').width(),
                            'position' : 'fixed',
                            'bottom' : 'auto',
                            'top' : '120px'

                        });

                    } else if(window.pageYOffset <= '220'){

                        console.log('relative');

                        $('.module .snap-box').removeClass('snap');
                        $('.module .snap-box').css({

                            'width' : $('.col-md-8').width(),
                            'position' : 'relative',
                            'bottom' : 'auto',
                            'top' : 'auto'

                        });

                    } else{

                        $('.module .col-md-8').css({

                            'position' : 'static'

                        });

                        $('.module .snap-box').removeClass('snap');

                        $('.module .snap-box').css({

                            'width' : $('.col-md-8').width(),
                            'position' : 'absolute',
                            'bottom' : '0',
                            'top' : 'auto'

                        });

                    }

                }*/



            });

            $('.module .sidebar h3').unbind( "click" );
            $('.module .sidebar a').unbind( "click" );

            $('.module .sidebar h3').next().css({

                'display' : 'block'

            });

            sidebarAjax();

        }else{

            $('.module .sidebar h3').off().on('click touchend',function(e) {
                e.stopPropagation();

                $(this).next().slideToggle();
                $(this).toggleClass('active');

            });

            sidebarAjax();

            $('.module .sidebar a').each(function(){

                $(this).on('click touchend',function(e) {
                    e.stopPropagation();

                    if($(this).hasClass('has_children')) {

                        $(this).next().prepend('<li class="first-child hidden-sm hidden-md hidden-lg"><a href="' + $(this).attr('href') + '" data-pid="' + $(this).attr('data-pid') + '">' + $(this).text() + '</a></li>');

                    }else{

                        $('.module .sidebar h3').next().slideToggle();
                        $('.module .sidebar h3').toggleClass('active');

                    }
                });

            });

        }

    }

    // Fading of logins etc.

    $('.congrat .close-button').on('click', function(){

        $('.congrat').modal('hide');

    });

    $('.jumbotron .close-button, .action-login .close-button').on('click', function(e) {

        $(this).parent().fadeToggle();

        if(uli){

            $('#currentSet').val('');
            $('#passwordSet').val('');
            $('#confirmSet').val('');

        }

    });

    $('.book-appointment-form .close-button').on('click', function(e) {

        setTimeout(
            function() {

                gwrf_35.reloadForm();
                gwrf_34.reloadForm();

            },
            1000);

    });

    $('.modal').on('shown.bs.modal', function () {

        $(".modal .book-appointment-form").show();
        $("html, body").css("overflow", "hidden");

        if( Modernizr.touch && $(window).width() <= 768 ){

            $('body').css({
                position: 'fixed'
            });

        }

    });

    $('.modal').on('hidden.bs.modal', function () {
        $("html, body").css("overflow", "visible");

        if( Modernizr.touch && $(window).width() <= 768 ) {

            $('body').css({
                position: 'initial'
            });

        }
    });

    $('.modal.loginapp').on('hidden.bs.modal', function () {

        $('.login-form').toggleClass('active');
        $('.blue-form, .book-appointment-form').each(function(){

            $(this).fadeOut();

        });
        $('.login-form').fadeToggle();

    });

    $('#chgPass').submit(function(e){

        e.preventDefault();

    });

    $('.forgot-password').on('click touchend', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('.login-form').fadeOut();
        $('.forgot-password-form').fadeIn();

    });

    $('#homeLogin').on('click', function(e) {

        e.stopPropagation();
        e.preventDefault();

        $('.login-form').toggleClass('active');

        $('.blue-form, .book-appointment-form').each(function(){

            if(!$(this).hasClass('login-form')){

                $(this).fadeOut();

            }

        });

        if($('.menu-bar').width() < 768){

            if($('.login-form').hasClass('active')){

                $('html, body').scrollTop(0);

            }

        }

        $('.login-form').fadeToggle();

    });

    displayChangePassword();

    function displayChangePassword(){

        $('#changePassword').on('click touchend', function(e) {
            e.stopPropagation();

            e.preventDefault();
            $('.change-password-form').toggleClass('active');
            $('.change-password-form').fadeToggle();
            $('.book-appointment-form').fadeOut();

        });

    }

    $('form#login').on('submit', function(e){
        $('form#login p.status').show().text(ajax_login_object.loadingmessage);

        var ajaxData = {

                'action': 'ajaxlogin',
                'username': $('form#login #username').val(),
                'password': $('form#login #password').val(),
                'security': $('form#login #security').val()

        };

        if($('#favouriteSelected').length > 0){

            ajaxData = {

                'action': 'ajaxlogin',
                'username': $('form#login #username').val(),
                'password': $('form#login #password').val(),
                'security': $('form#login #security').val(),
                'favid' : $('#favouriteSelected').val()

            };

        }

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_login_object.ajaxurl,
            data: ajaxData,
            success: function(data){

                $('form#login p.status').text(data.message);

                if($('#favouriteSelected').length > 0 && $('#favouriteSelected').val() != ''){

                    var button = $('.mwg_favorite');

                    $.ajax({
                        url:  '/wp-admin/admin-ajax.php',
                        data : {
                            action : 'add_favorite',
                            post_id : button.data('id')
                        },
                        success: function( data ) {



                            if (data.status)
                            {
                                if (data.current == 'favorite')
                                {
                                    button.data('action','remove_favorite');
                                    button.children('.fav-text').text('REMOVE FAVE');
                                }
                                else
                                {
                                    button.data('action','add_favorite');
                                    button.children('.fav-text').text('FAVE');
                                }

                                button.children('.icon').toggleClass('alt');



                            }
                        }
                    });

                }

                if (data.loggedin == true){

                    $.ajax({
                        url: '/wp-admin/admin-ajax.php',
                        data : {
                            action : 'check_user_first_login'
                        },
                        success: function( data ) {


                            if( reloadPage ){

                                window.location.reload();

                            }else {

                                $('.login-form').fadeOut();

                                loginSetup();

                                $('.learnbox').each(function(){

                                    $(this).find('.disabled-overlay').remove();

                                    if($(this).find('h4:contains("quiz")') && $(this).find('.icon').hasClass('do')){

                                        $(this).find('.read-more').text('DO QUIZ');

                                    }else if($(this).find('.icon').hasClass('watch')){


                                        $(this).find('.read-more').text('WATCH NOW');

                                    }else{

                                        $(this).find('.read-more').text('READ MORE');

                                    }


                                })

                                displayChangePassword();

                                if (data.firstLogin)
                                {

                                    $('.set-password-form').fadeIn();

                                }

                                $('.loginapp').modal('hide');

                            }

                        }
                    });

                }
            },
            error: function(data){

                console.log("error " + data);
                $('.login-form .error-message').fadeIn();

            }
        });
        e.preventDefault();
    });


    $('#actionLogin .forgot-password').on('click touchend', function(e) {
        e.stopPropagation();

        e.preventDefault();

        $('.action-login').fadeOut();
        $('#loginForm').modal('show');
        $('#loginForm .login-form').fadeOut();
        $('#loginForm .forgot-password').fadeIn();

    });

    $('#bookLogin').on('click', function(e) {
        e.stopPropagation();

        $('.book-appointment-form').toggleClass('active');
        $('.jumbotron .blue-form').each(function(){

            if(!$(this).hasClass('.book-appointment-form')){

                $(this).fadeOut();

            }

        });

        if($('.menu-bar').width() < 768){

            if($('.book-appointment-form').hasClass('active')){

                $('html, body').scrollTop(0);

            }

        }

        $('.book-appointment-form').fadeToggle();
        gwrf_34.reloadForm();

    });

    // Action Plan

    $('#displayLogin').on('click touchend',function(e) {
        e.stopPropagation();

        $('#congrat').modal('hide');
        $('.loginform').show();


    });

    function loginSetup(){

        var dash = '<div class="button dash clearfix">';
        dash += '<span>&nbsp;MY DASHBOARD</span>';
        dash += '<div class="menu-logged-in-menu-container">';
        dash += '<ul id="menu-logged-in-menu" class="menu">';
        dash += '<li><a href="' + siteurl + 'dashboard/">Go to my Dashboard</a></li>';
        dash += '<li><a id="changePassword" href="#">Change Password</a></li>';
        dash += '<li><a href="' + siteurl + 'logout/">Logout</a></li></ul></div></div>';

        $( "#homeLogin, #internalLogin" ).before( dash );
        $( "#homeLogin, #internalLogin" ).remove();
        $('.glossary-footer .col-md-2:first-child ul').append('<li><h4><a href="' + siteurl + 'dashboard/">MY DASHBOARD</a></h4></li>');


    }

    $('body').delegate('.action-step .icon', 'click touchend', function(e) {
        e.stopPropagation();

        var tick = $(this).closest('.action-step');

        if($('.menu-logged-in-menu-container').length > 0 || uli){

            updateActionPlan(tick.data('action'),tick.data('journey_id'),tick.data('id'));

        }else{

            $('.action-login, .action-login .form-holder, .congrat .blue-form').fadeIn();
            $('.congrat .blue-form .modal-dialog').css({

                display: "block"

            })
            $('#selectedActionPlan').val(tick.data('journey_id'));
            selectedTick = tick;
            $('#selectedAction').val(tick.data('action'));
            $('#selectedActionId').val(tick.data('id'));
            $('#username').focus();

            $('html,body').animate({
                    scrollTop: $(".action-login").offset().top - 120},
                'slow');

        }

    });

    $('form#actionlogin').on('submit', function(e){
        e.preventDefault();
        $('form#actionlogin p.status').show().text(ajax_login_object.loadingmessage);

        var ajaxData = {

            'action': 'ajaxlogin',
            'username': $('form#actionlogin #username').val(),
            'password': $('form#actionlogin #password').val(),
            'security': $('form#actionlogin #security').val()

        };

        if($('#selectedActionPlan').length > 0){

            ajaxData = {

                'action': 'ajaxlogin',
                'username': $('form#actionlogin #username').val(),
                'password': $('form#actionlogin #password').val(),
                'security': $('form#actionlogin #security').val(),
                'actionid' : $('#selectedActionId').val(),
                'journeyid' : $('#selectedActionPlan').val()

            };


        }

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_login_object.ajaxurl,
            data: ajaxData})
            .done(function(data){

                $('form#login p.status').text(data.message);
                loginSetup();
                $('.action-login').hide();

                $.ajax({
                    dataType: 'json',
                    url:'/wp-admin/admin-ajax.php',
                    data: {
                        action: 'get_action_steps',
                        postid: currentpost,
                        ajax: true
                    },
                    success: function(data){

                        var actionCount = 0;
                        var alreadyStarted = false;

                        $.each(data.complete, function(key, value) {

                            if( value.value === true){

                                $('.action-step[data-id=' + value.id + ']').find('.icon').removeClass('unchecked');
                                $('.action-step[data-id=' + value.id + ']').find('.icon').addClass('checked');

                                alreadyStarted = true;

                            }else{

                                $('.action-step[data-id=' + value.id + ']').find('.icon').removeClass('checked');
                                $('.action-step[data-id=' + value.id + ']').find('.icon').addClass('unchecked');

                            }


                        });

                        if(alreadyStarted){

                            $('.action-step[data-id=' + $('#selectedActionId').val() + ']').find('.icon').removeClass('unchecked');
                            $('.action-step[data-id=' + $('#selectedActionId').val() + ']').find('.icon').addClass('checked');

                        }


                        updateActionPlan($('#selectedAction').val(),$('#selectedActionPlan').val(),$('#selectedActionId').val());

                    },
                    error: function(data){

                        console.log(data);

                    }
                });

            })
            .fail(function(data){

                console.log(data);
                $('.error-message').fadeIn();

            })
    });


    if(checkAction){

        updateActionPlan($('#selectedAction').val(),$('#selectedActionPlan').val(),$('#selectedActionId').val());

    }

    $('form#firstPass').on('submit', function(e){
        e.preventDefault();
        $('form#firstPass p.status').show().text(ajax_login_object.loadingmessage);
        $.ajax({
            url: ajax_login_object.ajaxurl,
            data: {
                action: 'set_new_password',
                nonce: $('#mwg_new_password').val(),
                password: $('form#firstPass #firstPassword').val() },
            success: function(data){

                if (data.status){

                    $('form#firstPass p.status').text(data.message);

                    $('.set-password-form').fadeOut(function(){

                        $(this).remove();

                    });
                }
            },
            error: function(data){

                $('.set-password-form .error-message').fadeIn();

            }
        });
    });

    $('form#lostPass').on('submit', function(e){
        e.preventDefault();
        $('form#lostPass p.status').show().text(ajax_login_object.loadingmessage);
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_login_object.ajaxurl,
            data: {
                action: 'forgot_password',
                nonce: $('#lost_password').val(),
                user_login: $('form#lostPass #user_login').val(),
                ajax: true
            },
            success: function(data){

                if (data.success){

                    $('.forgot-error').fadeOut();
                    $('.forgot-password-form').fadeOut();

                } else{

                    $('.forgot-password-form .error-message .login-msg').text(data.errors);
                    $('.forgot-password-form .error-message').fadeIn();

                }
            },
            error: function(data){

                $('.forgot-password-form .error-message').fadeIn();

            }
        });
    });

    function updateActionPlan(action,journey,post){

        var tick = $('*[data-id="' + post + '"]');

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data : {
                action : action,
                journey_id : journey,
                post_id : post
            }
        }).done(function( data ) {

                if (data.current == 'complete')
                {
                    if(checkCurrentJourney() === false){

                        $('.loginform').hide();
                        $('#congrat').modal('show');
                        $('#congrat .blue-form').css({

                            display: "inline-block"

                        });

                    }

                }

                if (data.status)
                {

                    if (data.current == 'complete')
                    {

                        tick.data('action','mark_incomplete');
                        tick.find('.icon').removeClass('unchecked');
                        tick.find('.icon').addClass('checked');

                    }
                    else
                    {
                        tick.data('action','mark_complete');
                        tick.find('.icon').removeClass('checked');
                        tick.find('.icon').addClass('unchecked');
                    }

                }

        }).always(function( data ) {



        });
    }

    function checkCurrentJourney(){

        var actionCounter = 0;

        $('.action-step').each(function(){

            if($(this).find('.icon').hasClass('checked')){

                actionCounter = actionCounter + 1;

            }

        })

        if(actionCounter > 0){

            return true;

        }

        return false;

    }


    // Favourite Button

    jQuery(function($){
        $('body').delegate('.mwg_favorite', 'click touchend', function(e) {
            e.stopPropagation();
            var button = $(this);

            if($('.menu-logged-in-menu-container').length > 0){

                $.ajax({
                    url:  '/wp-admin/admin-ajax.php',
                    data : {
                        action : $(this).data('action'),
                        post_id : $(this).data('id')
                    },
                    success: function( data ) {
                        if (data.status)
                        {
                            /*console.log(button);
                             console.log(button.data('action'));
                             console.log(data.current);*/

                            if (data.current == 'favorite')
                            {
                                button.data('action','remove_favorite');
                                button.children('.fav-text').text('REMOVE FAVE');
                            }
                            else
                            {
                                button.data('action','add_favorite');
                                button.children('.fav-text').text('FAVE');
                            }

                            button.children('.icon').toggleClass('alt');

                        }
                    }
                });

            }else{

                $('#loginForm').modal('show');
                $('#favouriteSelected').val($(this).data('id'));

            }

        });

    });

    mwg_goal_updates();
    mwg_goal_delete();
    mwg_goal_edit();

    function mwg_goal_edit(){

        $('.mwg_goal_edit').off().on('click touchend', function(e) {
            e.stopPropagation();

            var button = $(this);
            var editable = false;

            if(button.closest('li').hasClass('editable')){

                editable = true;

            }

            $('#goalsContainer').find('li:not(:first-child)').each(function(){

                $(this).removeClass('editable');
                $(this).find('.goal-content span').show();
                $(this).find('form').hide();
                $(this).find('.functions-area.bottom').hide();

            });

            if(!editable){

                $(this).closest('li').toggleClass('editable');
                $(this).closest('li').find('form').toggle();
                $(this).closest('li').find('.goal-content span').toggle();
                $(this).closest('li').find('.functions-area.bottom').fadeIn();

            }else{

                $(this).closest('li').find('.functions-area.bottom').fadeOut();

            }

        });

    }

    $( "#chgPass input, #login input, #lostPass input" ).focus(function() {

        $('.error-message').fadeOut();

    });

    function mwg_goal_updates(){

        $('.mwg_goal_update').off().on('click touchend', function(e) {
            e.stopPropagation();
            var button = $(this);
            var bodyContent = button.closest('.editable').find('textarea').val();

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'goal_update',
                    goal_id: button.data('id'),
                    body:    bodyContent
                },
                success: function (data) {


                },
                complete: function (data) {

                    button.closest('.content-area .textarea').fadeOut();

                    if (data.status) {

                        button.closest('li').find('.goal-content span').text(bodyContent);

                        $('#goalsContainer').find('li:not(:first-child)').each(function(){
                            $(this).removeClass('editable');
                            $(this).find('.goal-content span').show();
                            $(this).find('form').hide();
                            $(this).find('.functions-area.bottom').hide();

                        });

                    }

                }
            });
        });
    };

    function mwg_goal_delete(){
        $('.mwg_goal_delete').off().on('click touchend', function(e) {
            e.stopPropagation();
            var button = $(this);
            if (confirm('Are you sure you want to delete this Goal?')) {
                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    data: {
                        action: 'goal_delete',
                        goal_id: $(this).data('id')

                    },
                    success: function (data) {
                        if (data.status) {

                            // object deleted - update frontend.
                            button.closest('li').fadeOut("normal", function() {
                                $(this).remove();
                                updateGoalNumbers();
                            });

                        }
                        else
                        {
                            // Object not deleted -  alert user.
                        }
                    }
                });
            }
        });
    };

    jQuery(function($){

        $('body').delegate('.mwg_goal_add', 'click touchend', function(e) {
            e.stopPropagation();

            var button = $(this);

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'goal_create',
                    body:    $('#addGoalTextfield').val()
                },
                success: function (data) {

                    if (data.status) {

                        addNewGoal(data.id,$('#addGoalTextfield').val());

                        $('#addGoalTextfield').val(' ');

                        $('#addNewGoal').hide();

                        $('#goalsContainer').find('li:not(:first-child)').each(function(){

                            $(this).removeClass('editable');
                            $(this).find('.goal-content span').show();
                            $(this).find('form').hide();
                            $(this).find('.functions-area.bottom').hide();

                        });

                    }
                    else
                    {
                        // Object not deleted -  alert user.
                    }
                }
            });
        });
    });

    function addNewGoal($postid,$content){

        $('#goalsContainer .content-area ul').append("<li class='clearfix'><hr><div class='textarea'><div class='goal-number'>1</div></div><div class='functions-area'><div class='mwg_goal_edit icon edit-small' data-id='" + $postid + "'></div></div><div class='col-md-12 goal-content'><span>" + $content + "</span><form action='#' method='post' class='form'><input name='action' value='mwg_update_add' type='hidden'><input type='hidden' id='mwg_update_add' name='mwg_update_add' value='" + $postid + "'><input type='hidden' name='_wp_http_referer' value='/dashboard/'><textarea placeholder='Enter in your goal...' name='body'>" + $content + "</textarea><input type='hidden'></form></div><div class='functions-area bottom'><div class='mwg_goal_delete icon delete-small' data-id='" + $postid + "'></div><div class='mwg_goal_update icon favourite-small' data-id='" + $postid + "'></div></div></li>");

        updateGoalNumbers();

        mwg_goal_updates();
        mwg_goal_delete();
        mwg_goal_edit();

    }

    jQuery(function($){
        $('body').delegate('.mwg_goal_clear', 'click touchend', function(e) {
            e.stopPropagation();
            var button = $(this);
            $('#addGoalTextfield').val('');
            $('#addNewGoal').fadeOut();
        });
    });



    // Update Goal Number

    function updateGoalNumbers(){

        var baseGoalNumber = 1;

        $('.goal-number').each(function(){

            $(this).text(baseGoalNumber);

            baseGoalNumber++;

        })

        if(baseGoalNumber <= 1){

            $('<div class="goal-pre textarea">It’s not a goal unless it’s in writing. Create your first goal here.</div>').insertAfter('.add-new-goal');
        }else{

            $('.goal-pre').remove();

        }

    };

    // Learn Filters
    var initialVal = 0;
    var last = '';

    $('.learn-filters .circle, .learn .show-all').on('click touchend', function(e) {
        e.stopPropagation();

        var thisOne = $(this);
        var filter = $(this).attr('data-filter');

        if($(this).find('.icon').hasClass('active') || $(this).hasClass('show-all')){

            $('.learn-filters .circle .icon').each(function(){

                if($(this) != thisOne){

                    $(this).removeClass('active');

                }

            });

            $('.content-box.learnbox').each(function(){

                $(this).fadeIn();

            });

        }else{

            $('.learn-filters .circle .icon').each(function(){

                if($(this) != thisOne){

                    $(this).removeClass('active');

                }

            });

            $(this).find('.icon').toggleClass('active');

            $('.content-box.learnbox').each(function(){

                if($(this).attr('data-type') == "sort_" + filter){

                    console.log("sort_" + $(this).attr('data-type'));

                    $(this).fadeIn();

                }else{

                    $(this).fadeOut();

                }


            });

        }

        /*
        if($(this).find('.icon').hasClass('active')){

            $(this).find('.icon').removeClass('active');
            $(this).find('.icon').removeAttr('newpos');
            initialVal = initialVal - 1;
            $('[data-holder="' + filter + '"]').insertAfter($('.learn-holder').last());

            $('.learn-filters .circle .icon').each(function(){

                if($(this).attr('newpos') > initialVal ){

                    $(this).attr('newpos', $(this).attr('newpos') - 1);
                    last = $(this).attr('data-filter');

                }

            })

            if(initialVal == 0){

                var i = 0;

                while(i < $('.learn-holder').length){

                    $('.learnbox-holder').append($('[data-initial="' + i + '"]'));
                    i = i + 1;
                }

            }

        }
        else{

            $(this).find('.icon').addClass('active');

            $('.learn-holder').each(function(){

                if($(this).attr('data-holder') == filter){

                    if(last == '' || initialVal == 0){

                        $('.learnbox-holder').prepend($(this));
                        last = filter;

                    }else{

                       $(this).insertAfter($('[data-holder="' + last + '"]').last());
                        last = filter;
                    }

                }

            });

            initialVal = initialVal + 1;
            $(this).find('.icon').attr('newpos',initialVal);

        }*/

    });

    $('.button.dash').on('click', function() {

        $('#menu-logged-in-menu').toggle();

    });

    // Dashboard Buttons

    $('#favouritesButton').on('click touchend', function(e) {
        e.stopPropagation();
        e.preventDefault();

       $('#favouritesContainer .content-area li .icon').each(function(){

           $(this).fadeToggle();

           if($(this).is(":visible")){

               $(this).css({

                   'display': 'inline-block'

               })

           }

       })

    });

    $('#goalsButton').on('click touchend', function(e) {
        e.stopPropagation();

        $('#addNewGoal').fadeToggle();
        $('#addGoalTextfield').focus();

    });

    $('#progressButton').on('touchend click', function(event) {
        event.stopPropagation(); event.preventDefault();

        $('#progressContainer .content-area li .icon').each(function(){

            if(!$(this).hasClass('progress-small')){

                $(this).fadeToggle();

            }

            if($(this).is(":visible") && !$(this).hasClass('progress-small')){

                $(this).css({

                    'display': 'inline-block'

                })

            }

        })

    });

    jQuery(function($) {
        $('body').delegate('.mwg_favorite_remove', 'click touchend', function(event) {
            event.stopPropagation(); event.preventDefault();

            var button = $(this);
            $.ajax({
                url:  '/wp-admin/admin-ajax.php',
                data : {
                    action : 'remove_favorite',
                    post_id : $(this).data('id')
                },
                success: function( data ) {
                    if (data.status)
                    {
                        console.log(data);
                        button.closest('li').fadeOut();
                    }
                }
            });
        });
    });

    jQuery(function($) {
        $('body').delegate('.mwg_journey_remove', 'click touchend', function(event) {
            event.stopPropagation();
            event.preventDefault();

            var button = $(this);
            $.ajax({
                url:  '/wp-admin/admin-ajax.php',
                data : {
                    action : 'journey_delete',
                    post_id : $(this).data('id')
                },
                success: function( data ) {
                    if (data.status)
                    {
                        button.closest('li').fadeOut();
                    }
                }
            });
        });
    });

    // Glossary Select

    // Poll

    updateProgress();

    var upgrade = null;

    if($(window).width() < '480'){

        if(upgrade != 1){

            $('.trending-scroller, .news-scroller').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true
            });

            upgrade = 1;

        }

    }

    if($(window).width() <= '992' && $(window).width() >= '481'){

        if(upgrade != 2){

            $('.trending-scroller, .news-scroller').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                autoplay: true
            });

            upgrade = 2;

        }

    }


    if($(window).width() > '992'){

        if(upgrade != 3){

            $('.trending-scroller, .news-scroller').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                autoplay: true
            });

            upgrade = 3;

        }



    }

    /**
     * Need to add in a pushstate and popstate
     */

    var leftArrow = $('.module .left-arrow');
    var rightArrow = $('.module .right-arrow');
    var totalModuleCount = $('#totalpages').val();
    var moduleCurrentPage = $('.current-page');

    $('.service .jumbo-menu a').on('click touchend',function(e){

        var button = $(this);
        var page = button.data('pageid');
        var team;

        if($('#team').length > 0){

            team = $('#team').val();

        }else{

            team = false;

        }

        e.preventDefault();
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'fetch_module_content',
                postid: page,
                services: true,
                team: team
            },
            success: function (data) {

                if (data.status) {

                    $('.col-md-8').text('');
                    $('.col-md-8').append('<h2 class="service">' + data.title + "</h2>");

                    if(data.content) {

                        console.log( data.content );
                        $('.col-md-8').append('<p>' + data.content + '</p>');

                    }

                    if(data.team){

                        var teamString;
                        var oldLocation = '';

                        if( team == 'team_members_hl') {

                            $.each(data.team, function (index, value) {

                                if (oldLocation != value.location) {

                                    teamString = '<div class="location"><span>' + value.location + "</span></div>";
                                    oldLocation = value.location;

                                } else {

                                    teamString = '';

                                }

                                $.each(value.member, function( memberKey, memberValue ){

                                    teamString += '<div class="our-team"><div class="display-tb"><div class="member-portrait">';
                                    teamString += '<img src="' + memberValue.image + '"/></div><div class="col-md-7"><div class="member-name">' + memberValue.full_name + '<div class="member-title">';
                                    teamString += '' + memberValue.title + '</div><div class="text"><strong>Mobile </strong>' + memberValue.mobile ;
                                    teamString += '' + '<br><strong>Email </strong><a href="mailto:' + memberValue.email + '">' + memberValue.email + '</a></div></div></div></div></div>';


                                });

                                $('.col-md-8').append(teamString);

                            });

                        }

                        else if(team == 'team_members_fa'){

                            $.each(data.team, function( index, value ) {

                                if(oldLocation != value.location){

                                    teamString = '<div class="location"><span>' + value.location + "</span></div>";
                                    oldLocation = value.location;

                                }else{

                                    teamString = '';

                                }

                                $.each(value.member, function( memberKey, memberValue ){

                                    teamString += '<div class="our-team"><div class="member-name">' + memberValue.full_name;
                                    teamString += '<div class="member-title">' + memberValue.title + '</div>';
                                    teamString += '<div class="member-desc">' + memberValue.description + '</div></div>';


                                });

                                $('.col-md-8').append(teamString);

                            });

                        }

                        else{

                            $.each(data.team, function( index, value ) {

                                teamString = '';

                                $.each(value.member, function( memberKey, memberValue ){

                                    teamString += '<div class="our-team"><div class="display-tb"><div class="member-portrait">';
                                    teamString += '<img src="' + memberValue.image + '"/></div><div class="col-md-7"><div class="member-name">' + memberValue.full_name + '<div class="member-title">';
                                    teamString += '' + memberValue.title + '</div></div></div></div>';
                                    teamString += '' + '<div class="member-desc">' + memberValue.description + '</div></div>';

                                });

                                $('.col-md-8').append(teamString);

                            });

                        }

                    }

                    $('.service .jumbo-menu a').each(function(){

                        $(this).removeClass('current-service');

                    });

                    button.addClass('current-service');

                    history.pushState("", "", button.attr('href'));

                }
            },
            error: function(data) {
                console.log('error 2');
            }
        });

    });

    function sidebarAjax(){
        $('.module .sidebar ul li a').off().on('click touchend',function(e) {
            e.stopPropagation();


            var button = $(this);
        var currentPage = (jQuery.inArray(button.data('pid'), pageArray)) + 1;
        e.preventDefault();
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'fetch_module_content',
                postid: button.data('pid')
            },
            success: function (data) {

                if (data.status) {

                    $('.wp-post-image').remove();

                    if(data.image){

                        $(data.image).insertAfter('.innergi_content');

                    }

                    $('.innergi_content').replaceWith(data.content);

                    history.pushState("", "", button.attr('href'));

                    leftArrow.attr('data-prevpage', parseInt(currentPage));
                    rightArrow.attr('data-nextpage', parseInt(currentPage));
                    moduleCurrentPage.text(currentPage);

                    if(button.hasClass('has_children')){

                        $('.title h3').text(data.title);

                        if(button.closest('li').hasClass('sel')){

                            button.closest('li').find('ul').slideUp("fast", function() {
                            });
                            button.closest('li').removeClass('sel');

                        }else{

                            button.closest('li').find('ul').slideDown("fast", function() {
                            });
                            button.closest('li').addClass('sel');

                        }

                    }else{

                        if($('h1').text() != data.parent_title){

                            $('.title h3').text(data.parent_title);

                        } else {

                            $('.title h3').text(data.title);

                        }

                    }

                    $('.col-md-8 h4:first-child').remove();

                    if(data.title && data.title != $('.internal .title.trend.center h3').text()){

                        $('.col-md-8 .snap-box').prepend('<h4>' + data.title + '</h4>');

                    }

                }
            },
            error: function(data) {
                console.log('error 2');
            }
        });

    });
    }

    $('.module .page-button .icon').on('click touchend',function(e) {
        e.stopPropagation();

        e.preventDefault();

        var link = $(this);
        var next = rightArrow.attr('data-nextpage');
        var prev = leftArrow.attr('data-prevpage');

        if(link.hasClass('left-arrow')){

            if(prev > 1){

                for(d = 0; d < pageArray.length; d++){

                    if(d == ( prev - 2)){

                        $.ajax({
                            url: '/wp-admin/admin-ajax.php',
                            data: {
                                action: 'fetch_module_content',
                                postid: pageArray[d]
                            },
                            success: function (data) {

                                if (data.status) {

                                    if(data.parent_title == $('h1').text()){

                                        $('.title h3').text(data.title);

                                    }else{


                                        $('.title h3').text(data.parent_title);

                                    }

                                    $('.col-md-8 h4:first-child').remove();

                                    if(data.title && data.title != $('.internal .title.trend.center h3').text()){

                                        $('.col-md-8 .snap-box').prepend('<h4>' + data.title + '</h4>');

                                    }

                                    $('.wp-post-image').remove();

                                    if(data.image){

                                        $(data.image).insertAfter('.innergi_content');

                                    }

                                    $('.innergi_content').replaceWith(data.content);
                                    history.pushState("", "", data.http);

                                    link.attr('data-prevpage', parseInt(prev) - 1);
                                    rightArrow.attr('data-nextpage', parseInt(next) - 1);
                                    moduleCurrentPage.text(parseInt(prev) - 1);

                                }
                            },
                            error: function(data) {
                                console.log('error 2');
                            }
                        });

                    }

                }

            }

        }else{

            if(next != totalModuleCount){

                for(d = 0; d < pageArray.length; d++){

                    if(d == next){

                        $.ajax({
                            url: '/wp-admin/admin-ajax.php',
                            data: {
                                action: 'fetch_module_content',
                                postid: pageArray[d]
                            },
                            success: function (data) {
                                if (data.status) {


                                    if(data.parent_title == $('h1').text()){

                                        $('.title h3').text(data.title);

                                    }else{


                                        $('.title h3').text(data.parent_title);

                                    }

                                    $('.col-md-8 h4:first-child').remove();

                                    if(data.title && data.title != $('.internal .title.trend.center h3').text()){

                                        $('.col-md-8 .snap-box').prepend('<h4>' + data.title + '</h4>');

                                    }


                                    $('.wp-post-image').remove();

                                    if(data.image){

                                        $(data.image).insertAfter('.innergi_content');

                                    }
                                    $('.innergi_content').replaceWith(data.content);
                                    history.pushState("", "", data.http);

                                    moduleCurrentPage.text(parseInt(next) + 1);
                                    leftArrow.attr('data-prevpage', parseInt(prev) + 1);
                                    link.attr('data-nextpage', parseInt(next) + 1);

                                }
                            },
                            error: function(data) {
                            }
                        });

                    }

                }

            }

        }

    });

    $('body').delegate('.mwg_change_password', 'click touchend', function(e) {
        e.stopPropagation();
        var button = $(this);
        var message = [];
        $('ajaxform').removeClass('error');

        $('#password_message').html('');

        if ($('#currentSet').val().length <= 0)
        {
            message.push('Please enter your current password<br />');
        }
        if ($('#passwordSet').val().length <= 0)
        {
            message.push('Please enter a new password<br />');
        }
        else if ($('#passwordSet').val() != $('#confirmSet').val())
        {
            message.push('Please ensure your new password matches the confirm<br />');
        }
        $('.change-password-form #password_message').fadeOut();
        $('.change-password-form .error-message').fadeOut();

        if (message.length >  0)
        {
            $.each(message,function(key, value ){
                $('#password_message').html($('#password_message').val() + "<br>"+ value);

            })

            $('.change-password-form .error-message .login-msg').html(message);
            $('.change-password-form .error-message').fadeIn();
        }
        else {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'change_password_save',
                    nonce: $('#mwg_change_password').val(),
                    current: $('#currentSet').val(),
                    password: $('#passwordSet').val(),
                    confirm: $('#confirmSet').val()

                },
                success: function (data) {
                    if (data.status) {
                        $('.change-password-form #password_message').html(data.message);
                        $('.change-password-form #password_message').fadeIn().delay(1000).fadeOut();
                    }
                    else {
                        $('.change-password-form .error-message .login-msg').text(data.message);
                        $('.change-password-form .error-message').fadeIn().delay(1000).fadeOut();
                    }
                },
                error: function(data) {
                    $('.change-password-form .error-message .login-msg').text("Please confirm your old password.");
                    $('.change-password-form .error-message').fadeIn().delay(1000).fadeOut();
                }
            });
        }
    });

    $( window ).smartresize(function() {

        updateProgress();
        resizeHolders();

        if($(window).width() < '480'){

            if(upgrade != 1){

                $('.trending-scroller, .news-scroller').slick('unslick');

                $('.trending-scroller, .news-scroller').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true
                });

                upgrade = 1;

            }

        }

        if($(window).width() <= '992' && $(window).width() >= '481'){

            if(upgrade != 2){
                $('.trending-scroller, .news-scroller').slick('unslick');

                $('.trending-scroller, .news-scroller').slick({
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    autoplay: true
                });

                upgrade = 2;

            }

        }

        if($(window).width() > '992'){

            if(upgrade != 3){
                $('.trending-scroller, .news-scroller').slick('unslick');

                $('.trending-scroller, .news-scroller').slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    autoplay: true
                });

                upgrade = 3;

            }

        }

    }).smartresize();

    function updateProgress(){

        $('.prog-bar').each(function(){

            var el = $(this);
            var child = el.find('.fill');
            var percent = child.attr('data-percent') / 100;
            var newWidth = el.width() * percent;

            child.css({

                'width' : newWidth

            });

        })

    }


    // FAQ Links Tabs

    $('.tabs li').on('click touchend',function(e) {
        e.stopPropagation();

        var tabopen = $(this).attr('data-tabopen');
        var tabhash = $(this).attr('data-hash');

        if(!$(this).hasClass('active')){

            $('.tabs li').removeClass('active');

            $(this).addClass('active');

            history.pushState('data', '', '#' + tabhash);

            $('.tab-content').each(function(){

                $(this).fadeOut();

                if($(this).attr('data-tabid') == tabopen){

                    $(this).fadeIn();
                }

            });

        }

    });

    // Your Journey

    resizeHolders();

    function resizeHolders(){

        $('.image-holder').each(function(){

            $(this).find(".hover-text").css({'top':$(this).height() - 60});

        })

    }


    $(".image-holder").hover(function() {

        $(this).find(".hover-text").stop().animate({

            'top':'0'

        },500);

        $(this).find(".hover-text h3").stop().animate({

            'height':$(this).height()

        },500);

        $(this).find(".hover-text h3.short").hide();
        $(this).find(".hover-text h3.full").css({

            'display' : 'table-cell'

        });

    }, function() {

        $(this).find(".hover-text").stop().animate({

            'top':$(this).height() - 60

        },500);

        $(this).find(".hover-text h3").stop().animate({

            'height':'60px'

        },500);


        $(this).find(".hover-text h3.short").show();
        $(this).find(".hover-text h3.full").hide();

    });

    // Update Search Posts

    $('#cat-amount').change(function () {
        var end = this.value;
        $('#postsPerPage').val(end);

        $('#searchForm').submit();

    });

    // Select 2 Setup

    $(".modal-content select, .jumbotron select, .pagination select").select2({

        minimumResultsForSearch: Infinity

    });

    // Anchor slide

    $('#syjAnchor').elEffect({

        targetEl: '#startYourJourney',
        effectType: 'anchor'

    });


});

// elEffect Function

(function($){

    $.fn.extend({

        elEffect: function(options) {

            'use strict';

            var defaults = {

                targetEl: null,
                effectType: 'toggle',
                userAction: 'click'

            };

            var options = $.extend(defaults, options);

            var el = $(this),
                targetEl = $(options.targetEl),
                effectType = $(options.effectType);

            if( options.userAction == 'click' && options.effectType != 'anchor'){

                el.on('click',function( e ){

                    e.preventDefault();
                    e.stopPropagation();

                    effectSwitch(targetEl, effectType);

                });

            }else if( options.effectType == 'anchor' ){

                el.click(function(e){

                    e.preventDefault();
                    e.stopPropagation();

                    if(targetEl){

                        $('html, body').animate({
                            scrollTop: targetEl.offset().top - $('.menu-bar').height()
                        }, 500);

                        return false;

                    }

                })

            }else{

                el.hover(function(e) {

                    effectSwitch(targetEl, effectType);

                });


            }

        }

    });

    // Check what effect type and affect elements

    function effectSwitch(targetEl, effectType){

        switch (effectType) {
            case 'fade':
                targetEl.fadeToggle();
                break;
            case 'slide':
                targetEl.slideToggle();
                break;
            default:
                targetEl.toggle();
        }

    }

})(jQuery);

// End elEffect

// Smart Resize Function

(function($,sr){

    var debounce = function (func, threshold, execAsap) {
        var timeout;

        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    }
    jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');

// End Smart Resize Function

$.extend($.expr[':'], {
    'containsi': function(elem, i, match, array)
    {
        return (elem.textContent || elem.innerText || '').toLowerCase()
                .indexOf((match[3])
                .toLowerCase()) >= 0;
    }
});

function highlightText( val ){

    if(findText != ''){

        var re = new RegExp(findText,"gi");

        $(".search-result h4:containsi('" + findText + "')").html(function(_, html) {
            return html.replace(re, "<span class='highlight-yellow'>" + findText + "</span>");
        });

        $(".search-result p:containsi('" + findText + "')").html(function(_, html) {
            return html.replace(re, "<span class='highlight-yellow'>" + findText + "</span>");
        });

    }

    if(val){

        findText = val;
        var re = new RegExp(findText,"gi");

        $(".ul-cont:containsi('" + findText + "')").html(function(_, html) {
            return html.replace(re, "<span class='highlight-yellow'>" + findText + "</span>");
        });

        $(".innergi_content:containsi('" + findText + "')").html(function(_, html) {
            return html.replace(re, "<span class='highlight-yellow'>" + findText + "</span>");
        });

    }
}

$(document).ready(function(){

    $.urlParam = function(name){
        var results = new RegExp('sval=(.+)$').exec(window.location.href);
        if (results==null){
            return '';
        }
        else{
            return results[1] || 0;
        }
    }

    var sVal = decodeURI($.urlParam('sval'));

    if(sVal != ''){

        highlightText(sVal);

    }else{

        highlightText();

    }


})
